import { Col, Row, Typography } from "antd";
import { RTBhouse } from "shared-components/Components/RTBhouse/web";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { useTheme } from "shared-components/Styles/ThemeHook";
import SimilarsLead from "../SimilarsLead/web";
import { useRouter } from "next/router";
import { useContact } from "../hook";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import getConfig from "next/config";
import { ModalState } from "../TextForm/type";
import dynamic from "next/dynamic";
import { useContext, useState } from "react";
import usePropertyData from "src/hooks/propertyData/usePropertyData";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useUser } from "shared-components/Components/User/User.hook";
const Modal = dynamic(
	() => import("shared-components/Components/Modal/web").then(mod => mod.Modal),
	{ ssr: false }
);

interface ContactInput {
	property_id: number;
	source: number;
	type: string;
	message?: string;
	visit_type?: string;
	date?: string;
	utm_args?: UtmArgs;
	isAutoGenerated?: boolean;
	queryRouter?: string;
	name?: string;
	email?: string;
	phone?: string;
	selectedCountryCode?: string;
}

interface UtmArgs {
	utm_content?: string | string[];
	utm_source?: string | string[];
	utm_medium?: string | string[];
	utm_campaign?: string | string[];
}

const { NODE_ENV } = getConfig().publicRuntimeConfig;

export const SimilarsLeadsModal = ({ id, onCancelSimilarsLead, formType, isProject, formData, isInListing, onComplete, setModalState, setFormType, reset, selectedCountryCode }) => {
    const { theme } = useTheme();
    const Router = useRouter();
    const screen = useBreakpoint();
    const [isSendingLeads, setIsSendingLeads] = useState(false);
    const { similars } = usePropertyData();
    const { site_name } = useContext(ConfigStateContext);
    const {
		isLoggedIn,
	} = useUser();

	const openModal = (type: number = 0) => {
		setFormType(type);
		setModalState(prevState => ({ ...prevState, similarModal: ModalState.OPEN }));
	};

	const handleClickShowNotification = async ({
		type = "success",
		message = "",
		description = "",
	}) => {
		const { showNotification } = await import(
			"shared-components/Components/CustomNotification/web"
		);
		showNotification(type, message, description);
	};

	const { contactMutation, doContactMutation, leadID } = useContact({
		id,
		onComplete: openModal,
		type: "lead",
		isProject,
		source: isInListing ? 22 : screen.lg ? 0 : 4,
		utm: Router.query,
		env: NODE_ENV == "development" || NODE_ENV == "beta" ? "development" : "production",
	});

	const MessageSuccessfull = ({ message, checkcircle = false }) => {
		return (
			<>
				{checkcircle ? (
					<Row justify={"center"} style={{ textAlign: "center" }}>
						<Col span={24}>
							<CheckCircleTwoTone
								twoToneColor="#52c41a"
								style={{ fontSize: "25px" }}
							/>
						</Col>
					</Row>
				) : (
					<Typography.Title
						level={4}
						style={{
							color: theme.colors.successColor,
							margin: 0,
							textAlign: "center",
							paddingBottom: "20px",
						}}>
						{"Consulta Enviada"}
					</Typography.Title>
				)}

				<Typography.Text
					style={{
						textAlign: "center",
						width: "100%",
						display: "block",
						paddingBottom: "20px",
					}}
					strong={checkcircle}>
					{message}
				</Typography.Text>
			</>
		);
	};

    const onSendSimilarsLead = propertyIds => {
        const values = {
            email: formData.email ? formData.email : 'invitado@mail.com',
            mensaje: `Hola, vi esta propiedad en ${site_name} y me interesa recibir más información. ¡Muchas gracias!`,
            nombre: formData.name ? formData.name : 'Invitado',
            telefono: formData.phone ? formData.phone : '999999999',
        }

        const leads = [...propertyIds].map(property_id => {
            const input: ContactInput = {
                property_id,
                message: values.mensaje,
                type: "PROPERTY",
                source: 11,
            };
            if (!isLoggedIn) {
                input.name= formData.name,
                input.email= formData.email,
                input.phone= formData.phone
            }

			if (
				Router.query &&
				(Router.query.utm_campaign ||
					Router.query.utm_content ||
					Router.query.utm_medium ||
					Router.query.utm_source)
			) {
				input.utm_args = {};
				if (Router.query.utm_campaign) {
					input.utm_args.utm_campaign = Array.isArray(Router.query.utm_campaign)
						? Router.query.utm_campaign[0]
						: Router.query.utm_campaign.toString();
				}
				if (Router.query.utm_content) {
					input.utm_args.utm_content = Array.isArray(Router.query.utm_content)
						? Router.query.utm_content[0]
						: Router.query.utm_content.toString();
				}
				if (Router.query.utm_medium) {
					input.utm_args.utm_medium = Array.isArray(Router.query.utm_medium)
						? Router.query.utm_medium[0]
						: Router.query.utm_medium.toString();
				}
				if (Router.query.utm_source) {
					input.utm_args.utm_source = Array.isArray(Router.query.utm_source)
						? Router.query.utm_source[0]
						: Router.query.utm_source.toString();
				}
			}

			if (!isLoggedIn) {
				return doContactMutation(0, true, {
					name: formData.name,
					phone: selectedCountryCode + formData.phone,
					email: formData.email,
					message: values.mensaje,
                    property_id,
                    type: "PROPERTY",
                    source: 11,
				});
			}
			return contactMutation({
				variables: {
					input,
				},
			});
		});

		setIsSendingLeads(true);

		Promise.all(leads)
			.then(_ => {
				handleClickShowNotification({ message: "¡Tu consulta fue enviada con éxito!" });
				setIsSendingLeads(false);
			})
			.catch(err => {
				handleClickShowNotification({
					message: "Ha ocurrido un error",
					description: "Hubo un error. Vuelva a intentarlo.",
					type: "error",
				});
				setModalState(prevState => ({ ...prevState, similarModal: ModalState.CLOSE }));
				if (onComplete) onComplete();
				if (reset) reset();
			})
			.finally(() => {
				setModalState(prevState => ({ ...prevState, similarModal: ModalState.CLOSE }));
				if (onComplete) onComplete();
				if (reset) reset();
			});
	};

    return (
        <>
            <RTBhouse page="ficha" data={[leadID, id]} />
            <Modal
                classes="similar-lead-modal"
                show
                onClose={onCancelSimilarsLead}
                width={(formType || !(similars && similars.length)) ? "420px" : "1024px"}
                footer={null}
                customIndex={1001}
            >
                {formType || !(similars && similars.length) ? (
                    <MessageSuccessfull
                        message={
                            isInListing || formType === 2
                                ? "¡Tu mensaje fue enviado al anunciante!"
                                : "¡Consulta enviada con éxito!"
                        }
                        checkcircle
                    />
                ) : (
                    <SimilarsLead
                        onSend={onSendSimilarsLead}
                        onCancel={onCancelSimilarsLead}
                        isSendingLeads={isSendingLeads}
                    />
                )}
            </Modal>
        </>
    )
}
